import React, { useCallback, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IRootState } from 'store'
import { closeToast } from 'store/toast'
import cssVariables from '../utils/css-variables'
import Icon, { iconTypes } from './Icon'

export const TYPE_SUCCESS = 'success'
export const TYPE_ERROR = 'error'

function Toast() {
  const showToast = useSelector<IRootState, boolean>(
    (state) => state.toast.showToast
  )
  const toastMessage = useSelector<IRootState, string>(
    (state) => state.toast.toastMessage
  )
  const cartIsOpened = useSelector<IRootState, boolean>(
    (state) => state.cart.opened
  )

  const dispatch = useDispatch()
  const timeoutRef = useRef<number | null>(null) // Use useRef to persist timeout

  const hideToast = useCallback(() => {
    dispatch(closeToast())
  }, [dispatch])

  useEffect(() => {
    if (showToast) {
      timeoutRef.current = window.setTimeout(() => {
        hideToast()
      }, 8000)
    }

    // Clear timeout when component unmounts or showToast changes
    return () => {
      if (timeoutRef.current !== null) {
        window.clearTimeout(timeoutRef.current)
        timeoutRef.current = null
      }
    }
  }, [showToast, hideToast])

  const removeHideAction = () => {
    if (timeoutRef.current !== null) {
      window.clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }
  }

  return (
    <div
      className={`toast ${showToast ? 'toast--show' : ''} ${
        cartIsOpened ? 'toast--cart-open' : ''
      }`}
      onMouseOver={removeHideAction}
    >
      <p
        className="toast__text js__toast-text"
        dangerouslySetInnerHTML={{ __html: toastMessage }}
      ></p>
      <Icon
        className="toast__close"
        name={iconTypes.close}
        size={16}
        color={cssVariables.colors.white}
        onClick={hideToast}
      />
    </div>
  )
}

export default Toast
